import React from "react";
import { ReactSVG } from "react-svg";
import poppetjeCollection from "../../../../assets/images/error/collection-of-poppetjes.svg";
import speechBubble from "../../../../assets/images/error/speech-bubble.svg";
import text from "../../../../assets/images/error/text.svg";
import fullSizeCloud from "../../../../assets/images/common/extra-big-cloud.svg";

const DesktopErrorPage = ({ navigateHome }) => {
    return (
        <div className="h-screen w-screen flex items-center justify-center bg-white overflow-hidden relative">
            <ReactSVG src={fullSizeCloud} className="opacity-50 absolute -left-[75rem] -top-[12rem] z-[1]" />
            <ReactSVG src={fullSizeCloud} className="opacity-50 absolute -right-[75rem] -top-[15rem] z-[1]" />
            <div className="text-center z-[10]">
                <h1 className="text-[100px] font-bold leading-[100px] text-standart-ocean">Something's <br /> not right</h1>
                <div className="flex">
                    <div className="-mt-[43px] -mr-[110px]">
                        <ReactSVG src={poppetjeCollection} />
                    </div>
                    <div className="flex">
                        <ReactSVG src={speechBubble} className="mt-[150px]" />
                        <ReactSVG src={text} className="-ml-[125px] mt-[163px]" />
                    </div>
                </div>
                {/* Hiding this temporarily */}
                {/* <button onClick={() => navigateHome()} className="mt-6 inline-block rounded bg-standart-ocean px-5 py-3 text-sm font-medium text-white hover:bg-light-purple active:text-black">
                    Go Back Home
                </button> */}
            </div>
        </div>
    )
}

export default DesktopErrorPage